<template>
    <div>
    <v-list  style="padding:0px" dense>
        <v-list-tile @click="$router.push('/')" :class="[way=='home'?'primary':'']">
          <v-list-tile-action>
            <v-icon :class="[way=='home'?'whitecolor':'']" :style="{fontSize:fontsize}">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title :class="[way=='home'?'whitecolor':'']">Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
    <v-divider></v-divider>
 <div class="text-xs-center"  v-if="fontsize=='2.5em'">
    <v-menu
      v-model="menu"
      :close-on-content-click="true"
      :nudge-width="200"
      offset-x
      right
    >
     <v-btn icon  slot="activator" >
      <v-icon color="#808080"  :style="{fontSize:'2.3em'}">receipt</v-icon>
    </v-btn>

      <v-card>
        <v-list dense>
          <v-list-tile  @click="$router.push('/dmrtransfer')"  >
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}"   >trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>DMR - Money Transfer</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>

        <v-list-tile  @click="$router.push('/last50recharge')"  >
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}"   >trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Last 50 Recharge</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>

        <v-list-tile  @click="$router.push('/dthbooking')"  >
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}"   >trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Dth Booking</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>

            <v-list-tile @click="$router.push('/searchrecharge')">
         <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
             <v-list-tile-content>
                <v-list-tile-title>Search Recharge</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/passbook')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Passbook(TopUp)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/passbookstatement')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Passbook(Statement)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/passbookwithdrawal')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Passbook(Statement)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/peertopeerstatement')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Peer To Peer Statement</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/dailystatement')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Daily Statement</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/commissions')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Commission Earnings</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/mycommissions')">
          <v-list-tile-action>
            <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>My Commission Earnings</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

        </v-list>
      </v-card>
    </v-menu>
  </div>
            <v-list-group v-else>
            <v-list-tile slot="activator" >
                <v-list-tile-action>
                    <v-icon :style="{fontSize:fontsize}">receipt</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>Recharge Detail</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/dmrtransfer')" :class="[way=='dmrtransfer'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='dmrtransfer'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='dmrtransfer'?'whitecolor':'']">DMR - Money Transfer</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/last50recharge')" :class="[way=='last50recharge'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='last50recharge'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title :class="[way=='last50recharge'?'whitecolor':'']">Last 50 Recharge</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>


            <v-list-tile @click="$router.push('/dthbooking')" :class="[way=='dthbooking'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='dthbooking'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title :class="[way=='dthbooking'?'whitecolor':'']">DTH Booking</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>

            <v-list-tile @click="$router.push('/searchrecharge')" :class="[way=='searchrecharge'?'primary':'']">
         <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='searchrecharge'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
             <v-list-tile-content>
                <v-list-tile-title :class="[way=='searchrecharge'?'whitecolor':'']">Search Recharge</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/passbook')" :class="[way=='passbook'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}"  :class="[way=='passbook'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title  :class="[way=='passbook'?'whitecolor':'']">Passbook(TopUp)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/passbookstatement')" :class="[way=='passbookstatement'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='passbookstatement'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='passbookstatement'?'whitecolor':'']">Passbook(Statement)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
             <v-list-tile @click="$router.push('/passbookwithdrawal')" :class="[way=='passbookwithdrawal'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='passbookwithdrawal'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='passbookwithdrawal'?'whitecolor':'']">Passbook(Withdrawal)</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/peertopeerstatement')" :class="[way=='peertopeerstatement'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='peertopeerstatement'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='peertopeerstatement'?'whitecolor':'']">Peer To Peer Statement</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/dailystatement')" :class="[way=='dailystatement'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='dailystatement'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='dailystatement'?'whitecolor':'']">Daily Statement</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/commissions')" :class="[way=='commissions'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='commissions'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='commissions'?'whitecolor':'']">Commission Earnings</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
           <v-divider></v-divider>
            <v-list-tile @click="$router.push('/mycommissions')" :class="[way=='mycommissions'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='mycommissions'?'whitecolor':'']">trending_flat</v-icon>
          </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="[way=='mycommissions'?'whitecolor':'']">My Commission Earnings</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </v-list-group>
           <v-divider></v-divider>

        <v-list-tile @click="$router.push('/offers')" :class="[way=='offers'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='offers'?'whitecolor':'']">local_offer</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="[way=='offers'?'whitecolor':'']">Check Offers</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile >
         <v-divider></v-divider>
          <v-list-tile @click="$router.push('/settings')" :class="[way=='settings'?'primary':'']">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}" :class="[way=='settings'?'whitecolor':'']">settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="[way=='settings'?'whitecolor':'']">Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-divider></v-divider>
        <v-list-tile @click="$router.push('/qrcode')"  :class="[way=='qrcode'?'primary':'']">
          <v-list-tile-action>
            <div v-if="fontsize=='2.5em'" >
              <img :src="require('../assets/qr-codew.svg')" style="padding-top:5px;margin-left:5px" v-if="way=='qrcode'" :width="25"/>
              <img :src="require('../assets/qr-code.svg')" v-else :width="25"  style="padding-top:5px;margin-left:5px"/>
            </div>
            <div  v-else >
              <img :src="require('../assets/qr-codew.svg')" v-if="way=='qrcode'" :width="20"/>
              <img :src="require('../assets/qr-code.svg')" v-else :width="20"/>
            </div>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="[way=='qrcode'?'whitecolor':'']">Generate QR Code</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
           <v-divider></v-divider>

        <v-list-tile @click="openb2c" :class="[way==''?'primary':'']">
          <v-list-tile-action>
              <img :src="require('../assets/playstore.svg')" v-if="fontsize=='2.5em'" :width="30"/>
              <img :src="require('../assets/playstore.svg')" v-else :width="20"/>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title  :class="[way==''?'whitecolor':'']">B2C APP</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-divider></v-divider>

        <v-list-tile @click="opend2r" :class="[way==''?'primary':'']">
          <v-list-tile-action>
              <img :src="require('../assets/playstore.svg')" v-if="fontsize=='2.5em'" :width="30"/>
              <img :src="require('../assets/playstore.svg')" v-else :width="20"/>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title  :class="[way==''?'whitecolor':'']">D2R APP</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-divider></v-divider>


      </v-list>
    <v-list two-line  style="padding:0px;margin:0px;">
          <v-list-tile @click=""  :class="[way==''?'primary':'']">
            <v-list-tile-action>
              <v-icon color="indigo"  :class="[way==''?'whitecolor':'']">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{support}}</v-list-tile-title>
              <v-list-tile-sub-title>For Support</v-list-tile-sub-title>
            </v-list-tile-content>
             </v-list-tile>
           <v-divider></v-divider>
        </v-list>
    </div>
</template>

<script>
export default {
    props:["fsize"],
    data(){
        return{
            way :"home",
            fontsize:"1.8em",
            menu:false,
            support: "",
        }
    },
    computed:{

    },
    methods:{
      opend2r(){
        let url = "https://play.google.com/store/apps/details?id=com.bonrixmobile.b2crechargenew"
         var win = window.open(url, '_blank');
         win.focus();

      },
      openb2c(){
        let url = "https://play.google.com/store/apps/details?id=com.bonrixmobile.b2crecharge"
         var win = window.open(url, '_blank');
         win.focus();
      }
    },
    watch:{
        $route (to, from){
          this.way = to.name;
          console.log(this.way);

        },
        fsize(value){
            this.fontsize = value
        },
    },
    mounted(){
        let vm = this;
        vm.fontsize =vm.$props.fsize;
        vm.$store.dispatch("axiosget",{
          url: 'HelpLine_Number',
          data: {}
        }).then(function (res) {
          vm.support = res.data.Message;
        })

    }
}
</script>

<style>
.whitecolor{
    color:white!important;
}
</style>
